/**
 * Authentication API functions.
 */
import apiClient from './client';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export interface UserResponse {
  id: number;
  email: string;
  name: string;
  is_active: boolean;
  is_admin: boolean;
  created_at: string;
}

/**
 * Login with email and password.
 */
export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('/api/auth/login', credentials);
  return response.data;
};

/**
 * Logout (clears httpOnly cookie on backend).
 * SEC-003: Cookie is cleared by backend, no need to clear localStorage.
 */
export const logout = async (): Promise<void> => {
  try {
    await apiClient.post('/api/auth/logout');
  } catch (error) {
    // Ignore errors on logout
  }
  // SEC-003: No need to clear localStorage - backend clears httpOnly cookie
};

/**
 * Get current user information.
 */
export const getCurrentUser = async (): Promise<UserResponse> => {
  const response = await apiClient.get<UserResponse>('/api/auth/me');
  return response.data;
};

